import React, {useEffect, useState} from "react";
import {Card, Box, CardContent, TextField, Grid, Typography, Button, CircularProgress} from "@material-ui/core";
import VetAvailabilityListItem from "../../Components/ListItems/RemoveVetAvailability";
import { Autocomplete } from "@material-ui/lab";
import { Title } from "react-admin";
import API from "../../helpers/apiHelpers";
import { timezones } from "../../Constants/timezones";
import moment from "moment";
import { useSnackbar } from "notistack";

const RemoveVetAvailability = () => {
    const [vets, setVets] = React.useState<undefined | any>([]);
    const [workdays, setWorkdays] = React.useState<undefined | any>([]);
    const [vet, setVet] = React.useState<undefined | any>();
    const [timeZone, setTimeZone] = useState("UTC");
    const [selectedWorkDay, setSelectedWorkDay] = useState(null);
    //set initial tz
    const [queryProfile, setQueryProfile] = React.useState<string>("");
    const { enqueueSnackbar } = useSnackbar();

    const getProfiles = async (vetName) => {
        try {
            const profileList = await API.getProfiles({type: "VET", name: vetName});
            setVets(profileList);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (queryProfile.length) {
            const timeOutId = setTimeout(() => getProfiles(queryProfile), 500);
            return () => clearTimeout(timeOutId);
        }
    }, [queryProfile]);

    useEffect(() => {
        if (timeZone !== "") {
            moment.tz.setDefault(timeZone);
        }
    }, [timeZone]);

    const handleSubmit = async () => {
        if (vet && timeZone !== ""){
            const resp = await API.removeVetSchedule(vet.id, selectedWorkDay);
            if (!resp?.id){
                enqueueSnackbar("There was an error submitting the form. Please be sure all fields are entered and valid.", {
                    variant: "error",
                    autoHideDuration: 4000
                });
            } else {
                enqueueSnackbar("Success!", {
                    variant: "success",
                    autoHideDuration: 4000
                });
                const profile = await API.getProfiles({id: vet.id});
                setVet(profile[0]);
                setWorkdays(profile[0].workDays);
                setSelectedWorkDay(null);
            }
        } else{
            if (!vet) {
                enqueueSnackbar("You need to choose a vet!", {
                    variant: "error",
                    autoHideDuration: 4000
                });
            } else if (timeZone === "") {
                enqueueSnackbar("You need to choose a timezone!", {
                    variant: "error",
                    autoHideDuration: 4000
                });
            }
        }
    };

    return (
        <Card style={{maxWidth: 800}}>
            <Title title="Remove Vet Availability" />
            <CardContent>
                <Typography variant="h3" style={{marginBottom: 20}}>
                    Remove vet availability
                </Typography>
                <Typography>
					This form is for removing a vet's availability from the schedule.
                </Typography>
            </CardContent>
            <>
                <CardContent>
                    <Typography variant="h6">
                Choose the Vet that you are updating.
                    </Typography>
                    <Autocomplete
                        id="vetProfile"
                        value={vet}
                        onChange={(event, value) => {
                            setVet(value);
                            setWorkdays(value.workDays);
                        }}
                        options={vets}
                        getOptionLabel={(option) => `Dr. ${option.firstName} ${option.lastName}`}
                        renderInput={(params) => <TextField {...params} variant="outlined" label="Vet" onChange={(event) => setQueryProfile(event.target.value)}/>}
                    />
                </CardContent>
                <CardContent>
                    <Typography variant="h6">
                Choose the applicable timezone.
                    </Typography>
                    <Autocomplete
                        options={timezones}
                        getOptionLabel={(option) => option}
                        value={timeZone}
                        onChange={(event, value) => {
                            if (value) {
                                setTimeZone(value);
                            }else{
                                setTimeZone("UTC");
                            }
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                    />
                </CardContent>
                <Box marginBottom="20px" />
                    {
                        (!vet || timeZone === "") ? null :
                        (!workdays.length) ?
                            <Grid item xs={12} container justify="center">
                                <Grid item xs={11} container justify="flex-start">
                                    <Typography>No availability found</Typography>
                                </Grid>
                            </Grid>:
                            <Grid item xs={11} container justify="flex-start">
                                <VetAvailabilityListItem
                                        name={`Dr. ${vet.firstName} ${vet.lastName}`}
                                        key={vet.profileId}
                                        profileId={vet.profileId}
                                        image={vet.image}
                                        userId={vet.id}
                                        workDays={workdays}
                                        selectedWorkDay={selectedWorkDay}
                                        setSelectedWorkDay={setSelectedWorkDay}
                                        timeZone={timeZone}
                                    />
                            </Grid>
                    }
                <CardContent>
                    <Button
                        variant="contained"
                        onClick={() => handleSubmit()}
                        color="primary"
                        disabled={(timeZone != "" && vet && selectedWorkDay) ? false : true}
                    >
                        Delete Selected Workday
                    </Button>
                </CardContent>
            </>
        </Card>
    );
};

export default RemoveVetAvailability;
